// import ccFetch from "../ccFetch";
// import { getToken, setToken, isValid, isExpired, getPayloadFromToken } from "./utils";
import * as utils from "./utils";
import defaults from "./defaults";
import Logon from './Logon'
import logoff from './logoff'
import ccAuthConnect from './ccAuthConnect'
import MultipleFetch from './MultipleFetch'
import ccAuthLogon from './ccAuthLogon'

export default function(params) {
  if (!params.notAuthenticated)
    throw new Error("Missed opt: notAuthenticated function");
  const args = {
    authDomain: params.authDomain || defaults.authDomain,
    authLogonUri: params.authLogonUri || defaults.authLogonUri,
    authLogoffUri: params.authLogoffUri || defaults.authLogoffUri,
    authRenewUri: params.authRenewUri || defaults.authRenewUri,
    tokenChanged: params.tokenChanged || defaults.tokenChanged,
    notAuthenticated: params.notAuthenticated
  }
  return {
    Logon: Logon(args),
    logoff: logoff(args),
    ccAuthConnect: ccAuthConnect(args),
    MultipleFetch: MultipleFetch(args),
    ccAuthLogon: ccAuthLogon(args),
    utils,
  };
}
